import type { ApiServerId } from '../app/core/services/api-server.service';

/** Development builds start on staging; super admins can still switch in Profile. */
export const DEFAULT_SERVER_ID: ApiServerId = 'staging';
